export const clampDateToBounds = (
    date: Date,
    minimumDate?: Date,
    maximumDate?: Date,
): Date => {
    if (minimumDate != null && date < minimumDate) {
        return minimumDate;
    }

    if (maximumDate != null && date > maximumDate) {
        return maximumDate;
    }

    return date;
};
